module.exports = __webpack_public_path__ + "img/notify.cc132e6d.svg";